/**
 * Sitenin TEK içerik kaynağı.
 * Buraya yalnızca onaylı, gerçek içerik girilir. Boş bırakılan alanlar dünyada hiç görünmez.
 */
export default {
    brand: 'llpause',
    domain: 'https://llpause.co',

    // Sekme başlığı ve paylaşım kartı (meta etiketleri src/index.html içinde)
    title: 'llpause',

    /**
     * Projeler — her proje dünyada bir durak olur (panolar + zemin yazısı + link alanı).
     * {
     *     slug: 'proje-klasor-adi',           // static/projects/<slug>/ altındaki görseller
     *     title: 'Proje adı',
     *     label: 'PROJE ADI',                 // dünyada devrilebilen 3D harflerle yazılır (büyük harf; Türkçe İ/I elle —
     *                                         // toUpperCase 'TAKIP', toLocaleUpperCase('tr') 'VİSİON' üretir)
     *     images: ['a.webp', 'b.webp'],       // panolarda gösterilir (en fazla 4; pano oranı 1.72:1 → 1280×744)
     *     href: 'https://...'                 // boş bırakılırsa link alanı çıkmaz
     * }
     */
    projects: [
        {
            // Kaynak: ~/Downloads/itü 2/sunum (başlık <title>'dan); sunum yayında değil → link yok
            slug: 'itu-gvo-kulturel',
            title: 'İTÜ GVO ve Kültürel',
            label: 'İTÜ GVO VE KÜLTÜREL',
            images: ['a.webp', 'b.webp', 'c.webp', 'd.webp'],
            href: ''
        },
        {
            // Kaynak: ~/Downloads/muratbeytuneID (video kareleri); sunum gizli adreste → link kullanıcı onayına bağlı
            slug: 'muratbey',
            title: 'Muratbey',
            label: 'MURATBEY',
            images: ['a.webp', 'b.webp', 'c.webp', 'd.webp'],
            href: ''
        }
,

        // Girişimler — kaynak: selmanyilmaz-live src/content/ventures/tr/*.md (title, order);
        // label = icerik/06-yatirim-girisimler.txt başlıkları
        // görseller: src/data/venture-covers.ts (a) + venture-media.ts (b)
        {
            slug: 'group-taiga',
            title: 'Group Taiga',
            label: 'GROUP TAIGA',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'lunaar-vision',
            title: 'Lunaar Vision',
            label: 'LUNAAR VISION',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'linkparty',
            title: 'LinkParty',
            label: 'LINKPARTY',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'evaste',
            title: 'Evaste',
            label: 'EVASTE',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'spectra',
            title: 'Spectra',
            label: 'SPECTRA',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'cleanplays',
            title: 'CleanPlays',
            label: 'CLEANPLAYS',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'hasta-takip',
            title: 'Hasta Takip',
            label: 'HASTA TAKİP',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'taiga-teknoloji',
            title: 'Taiga Teknoloji',
            label: 'TAIGA TEKNOLOJİ',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'greenmarket',
            title: 'GreenMarket',
            label: 'GREENMARKET',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'robotic-ai',
            title: 'RoboticAI',
            label: 'ROBOTICAI',
            images: ['a.webp', 'b.webp'],
            href: ''
        },
        {
            slug: 'taiga-inc',
            title: 'Taiga Inc.',
            label: 'TAIGA INC.',
            images: ['a.webp', 'b.webp'],
            href: ''
        }
    ],

    /**
     * İletişim — bilgi alanında basılabilir etiketler olur.
     * { label: 'E-POSTA', href: 'mailto:...' }
     */
    /**
     * Video istasyonları (domino → 9:16 panel). Dosyalar static/reels/<slug>.mp4 + <slug>.jpg (kapak).
     * Kaynak: ~/Downloads'taki TAIGA dikey videoları, 540×960 sessiz olarak sıkıştırıldı.
     * (Piano Flip ile Dark Drill görüntüsü aynı, yalnız müziği farklı → biri alındı.)
     */
    reels: [
        { slug: 'taiga-showreel-ig' },          // TAIGAShowreelReel56sIG.mp4
        { slug: 'taiga-showreel-2026' },        // TAIGA_Showreel_2026_Vertical_1080x1920.mp4
        { slug: 'taiga-hizli-showcase' },       // TAIGA_Dikey_Hizli_Showcase.mp4
        { slug: 'taiga-piano-flip' },           // TAIGA_Dikey_Piano_Flip_Woom.mp4
        { slug: 'taiga-logo-motion' }           // logomotion-720p.mp4
    ],

    // TAIGA anıtının altındaki satır (sunumlardaki "TAIGA Ai Studio" / "AI Studio" markası)
    taiga: {
        subtitle: 'AI STUDIO'
    },

    // Rubik küpü enstalasyonunun başlığı: devrilebilen 3D harflerle, satır satır (kullanıcı: "ai base creative gibi bir başlık")
    installation: {
        title: ['AI BASED', 'CREATIVE']
    },

    // Menü → İletişim, üstte kendi renginde kartlar (adresler 2026-09-25'te 200 döndü)
    websites: [
        { label: 'SELMAN YILMAZ', href: 'https://selmanyilmaz.co', tone: 'personal' },
        { label: 'GROUP TAIGA', href: 'https://grouptaiga.com', tone: 'taiga' }
    ],

    // Kaynak: selmanyilmaz-live src/data/site.ts
    contact: [
        { label: { tr: 'E-POSTA', en: 'EMAIL' }, href: 'mailto:selman@grouptaiga.com' },
        { label: 'LINKEDIN', href: 'https://www.linkedin.com/in/selmany' },
        { label: 'X', href: 'https://x.com/SelmanYilmaz_' },
        { label: 'INSTAGRAM', href: 'https://www.instagram.com/llpause/' }
    ]
}
